import React from 'react';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import BaseQueryClientProvider from 'app/BaseQueryClientProvider';
import { ModalProvider } from 'context/ModalContext';
import { RouteProvider } from 'context/RouterContext';
import { NuqsAdapter } from 'nuqs/adapters/react';
import Modals from 'pages/home/Modals';
import 'react-app-polyfill/ie11';
// For IE 11 support
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import packageJson from '../package.json';
import DefaultLayout from './app/DefaultLayout';
import QueryErrorBoundary from './app/QueryErrorBoundary';
import './i18n';
import './index.css';

console.log(`%cNE(O)RDINARY Project Name : ${packageJson.name}`, 'color:yellow');
console.log(`%cNE(O)RDINARY Project Version : ${packageJson.version}`, 'color:yellow');
console.log(`%cNE(O)RDINARY Project Made by : ${packageJson.author}`, 'color:yellow');

console.log(`
███╗   ██╗███████╗ ██╗ ██████╗ ██╗ ██████╗ ██████╗ ██╗███╗   ██╗ █████╗ ██████╗ ██╗   ██╗
████╗  ██║██╔════╝██╔╝██╔═══██╗╚██╗██╔══██╗██╔══██╗██║████╗  ██║██╔══██╗██╔══██╗╚██╗ ██╔╝
██╔██╗ ██║█████╗  ██║ ██║   ██║ ██║██████╔╝██║  ██║██║██╔██╗ ██║███████║██████╔╝ ╚████╔╝
██║╚██╗██║██╔══╝  ██║ ██║   ██║ ██║██╔══██╗██║  ██║██║██║╚██╗██║██╔══██║██╔══██╗  ╚██╔╝
██║ ╚████║███████╗╚██╗╚██████╔╝██╔╝██║  ██║██████╔╝██║██║ ╚████║██║  ██║██║  ██║   ██║
╚═╝  ╚═══╝╚══════╝ ╚═╝ ╚═════╝ ╚═╝ ╚═╝  ╚═╝╚═════╝ ╚═╝╚═╝  ╚═══╝╚═╝  ╚═╝╚═╝  ╚═╝   ╚═╝
`);

// App component with language detection
const App = () => {
  return (
    <BrowserRouter>
      <NuqsAdapter>
        <BaseQueryClientProvider>
          <QueryErrorBoundary>
            <ModalProvider>
              <RouteProvider>
                <Routes>
                  <Route path="/*" element={<DefaultLayout />} />
                </Routes>
                <Modals />
              </RouteProvider>
            </ModalProvider>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
          </QueryErrorBoundary>
        </BaseQueryClientProvider>
      </NuqsAdapter>
    </BrowserRouter>
  );
};

// 엣지(og-injector)가 크롤러 응답에 주입하는 #seo-content 를 JS 실행 즉시 제거.
// 비렌더링 봇(Yeti·AI봇)은 이 코드가 안 돌아 본문을 그대로 읽고,
// JS 를 렌더링하는 Googlebot/실사용자 화면에는 앱 UI 만 남는다 (docs/prerender-plan.md Phase 1).
document.getElementById('seo-content')?.remove();

// Containers
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(<App />);
